/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_Faq_Q5Inputs */

const en_guide_what_is_json_faq_q5 = /** @type {(inputs: Guide_What_Is_Json_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can a JSON file have more than one top-level value?`)
};

const ko_guide_what_is_json_faq_q5 = /** @type {(inputs: Guide_What_Is_Json_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 파일에 최상위 값이 여러 개 있을 수 있나요?`)
};

const ja_guide_what_is_json_faq_q5 = /** @type {(inputs: Guide_What_Is_Json_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON ファイルにトップレベルの値を複数持てますか?`)
};

/**
* | output |
* | --- |
* | "Can a JSON file have more than one top-level value?" |
*
* @param {Guide_What_Is_Json_Faq_Q5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_faq_q5 = /** @type {((inputs?: Guide_What_Is_Json_Faq_Q5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_Faq_Q5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_faq_q5(inputs)
	if (locale === "ko") return ko_guide_what_is_json_faq_q5(inputs)
	return ja_guide_what_is_json_faq_q5(inputs)
});